<template>
  <span>
    <v-btn icon flat>
      <v-icon small @click="dialog = true">
        mdi-pencil
      </v-icon>
    </v-btn>

    <v-dialog v-model="dialog" width="500" v-if="degradingPotentialForTax !== undefined">
      <v-card>
        <v-card-title class="headline green darken-2 white--text lighten-2">
          Editar Potencial Degradador
        </v-card-title>

        <v-card-text>

          <v-form v-model="valid">
            <v-text-field
              v-model="degradingPotentialForTax.name"
              :rules="requiredRules"
              label="Descrição"
              required></v-text-field>
            <v-checkbox
                v-model="degradingPotentialForTax.old"
                :checked="degradingPotentialForTax.old"
                label="Antigo?"
                required
            />
          </v-form>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="closeDialog()">Cancelar</v-btn>
          <v-btn color="primary" flat @click="editDegradingPotentialForTax">Atualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>

import DegradingPotentialForTaxService from '@/services/applications/configurations/DegradingPotentialForTaxService';
import validationRules from '@/mixins/validation-rules';

export default {
  name: 'EditDegradingPotentialForTax',
  components: {},
  mixins: [validationRules],
  props: ['typologyId', 'degradingPotentialForTax'],
  data() {
    return {
      requiredRules: [validationRules.required],
      dialog: false,
      valid: false,
    };
  },
  methods: {
    editDegradingPotentialForTax() {
      const vm = this;

      DegradingPotentialForTaxService
        .updateDegradingPotentialForTax(vm.typologyId, vm.degradingPotentialForTax)
        .then((response) => {
          vm.$swal({
            title: 'Potencial Degradador atualizado com Sucesso',
            text: '',
            type: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            vm.$emit('update', response.data);
            vm.closeDialog();
          });
        })
        .catch((error) => {
          vm.$swal({
            title: 'Erro',
            text: error.response.data.join('\n'),
            type: 'error',
            showConfirmButton: 'Ok',
          });
        });
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
